module.exports = __webpack_public_path__ + "static/media/icon-teams-hover.12c5e571.svg";